import React, { useEffect, useState } from "react"
import {FaImage, FaPersonBooth, FaRegUserCircle, FaUserCircle} from 'react-icons/fa'
import { Link } from "react-router-dom";



export default function Navbar(props){
    
    
    return(!props.showNavbar?(<div></div>):
        <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top" style={{opacity:"0.7"}}>
        <div className="container-fluid">
          <a className="navbar-brand" href="/"style={{fontFamily:"Monsterrat"}}><FaRegUserCircle/> Sanskar</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/aboutMe">About Me</a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/projects">Projects</Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/papers">Papers</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/workExperience">Work Experience</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
}